import React from 'react';
import { FadeIn } from './FadeIn';
const rows = [['Alumno que se aburre y se va', 'Tasa de abandono alta', '-$20.000 ARS/mes'], ['El que te cancela sobre la hora y no le cobrás', 'Dinero perdido cada semana', '-$5.000 ARS/semana'], ['Clases grupales improvisadas', 'Energía quemada — calidad baja', 'Incalculable'], ['Sin variantes por nivel', 'Clases frustrantes y alumnos desconectados', 'Pérdida de referidos'], ['3 hs de planificación × 40 semanas', '120 horas de tu vida por año', 'Tu tiempo libre']];
export function PilatesCost() {
  return <section className="bg-padel-dark px-4 py-16 sm:py-24" data-id="element-159" data-mp="12my0rxfvacy1">
      <div className="mx-auto max-w-5xl" data-id="element-160" data-mp="17g106m7bsgm5">
        <FadeIn data-id="element-161" data-mp="17h2dkxbtdf71">
          <h2 className="text-center font-display text-4xl font-black text-white" data-id="element-162" data-mp="9zlhpx8x0n9h">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </FadeIn>

        <div className="mt-9 overflow-hidden rounded-2xl border border-padel-muted" data-id="element-163" data-mp="ex3rtqyo58j2">
          <div className="grid grid-cols-3 bg-padel-surface" data-id="element-164" data-mp="2t3a9tnoaihlt">
            <p className="p-4 font-bold text-white" data-id="element-165" data-mp="2o5igqqbwspg1">Sin Método</p>
            <p className="border-l border-padel-muted p-4 font-bold text-white" data-id="element-166" data-mp="2o60ho09inrua">
              Costo real
            </p>
            <p className="border-l border-padel-muted p-4 font-bold text-red-400" data-id="element-167" data-mp="2fcwzxfru8stu">
              Dinero Perdido
            </p>
          </div>
          <div className="divide-y divide-padel-muted bg-padel-dark" data-id="element-168" data-mp="2aeveio6xwhf7">
            {rows.map(([without, cost, money], i) => <FadeIn key={without} delay={i * 0.05} data-id="element-169" data-mp="25dfw73w5cp0i" data-mpi={i}>
                <div className="grid grid-cols-3" data-id="element-170" data-mp="20ew7wwu2z14z">
                  <p className="p-4 text-sm text-gray-300" data-id="element-171" data-mp="20hqtirotyrzz">{without}</p>
                  <p className="border-l border-padel-muted p-4 text-sm text-gray-400" data-id="element-172" data-mp="1wfdwqss2a4fc">
                    {cost}
                  </p>
                  <p className="border-l border-padel-muted p-4 text-sm font-bold text-red-400" data-id="element-173" data-mp="3urclkip7hhjv">
                    {money}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.3} data-id="element-174" data-mp="1swoijxkkiz9s">
          <div className="mt-8 rounded-xl border border-red-500/20 bg-red-500/10 p-6 text-center" data-id="element-175" data-mp="1sxpxwe8ma7xb">
            <p className="font-display text-2xl font-black text-white" data-id="element-176" data-mp="1f6bew7epm6q9">
              Conclusión:{' '}
              <span className="text-red-400" data-id="element-177" data-mp="1j6v8j102qs7n">
                No comprar este pack te está costando más de $50.000 por mes.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}